




import React from "react";

const Contracts = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .contract-card { box-shadow:0 6px 15px rgba(0,0,0,0.1); border-radius:10px; }
        .badge-id { background:#e6f0ff; color:#3366ff; }
      `}</style>

      <h4>Contracts</h4>

      <div className="row">
        {[1,2,3,4,5,6,7,8].map(i => (
          <div key={i} className="col-md-3 mb-3">
            <div className="card p-3 contract-card">
              <span className="badge badge-id mb-2">274729</span>

              <h6>SEO Contracts</h6>
              <small className="text-muted">Category: Contracts under Seal</small>

              <p className="small mt-2">
                📅 23 Nov 2025 <br/>
                📂 Open till: 17 Dec 2025
              </p>

              <div className="bg-light p-2 rounded small">
                NovaWave LLC
              </div>

              <div className="mt-2 small text-primary">
                💰 Value: $2,04,214
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contracts;